export const stakingContract = "0xbd5Ce7322D34A354bFBBDb636058051b1b4cC90b";
export const presaleContract = "0x129CDE6DF20c5853b26321806fE23652F6F68E61";
export const tokenContract = "0xdD178eaDfef387d03207a7E81E2Ad0A86e5Fc85a";
